// フッター アコーディオンメニュー
function addMenuAcdEvent() {
  const acd = document.querySelectorAll('.js-acd');
  const openClass = 'is-open';

  if (acd) {
    acd.forEach(function (value) {
      value.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 768px)').matches) {
          value.classList.toggle(openClass);
        }
      });
    });
  }
}

window.addEventListener('DOMContentLoaded', addMenuAcdEvent);
